// Stammdaten fuer die Suche: einmal laden, lange behalten.
//
// Kommt aus /api/plates/bundle. Laender und Kennzeichen sind getrennt,
// damit die vielen Kennzeichen-Zeilen ihr Land nicht als Text mitschleppen
// (siehe Kommentar im Server).

import { useQuery } from "@tanstack/react-query";
import { holeBundleMitCache } from "./offlineBundle.js";

export type PlateScope = "region" | "state" | "federal" | "diplomatic" | "country";
export type PlateStatus = "aktuell" | "auslaufend" | "historisch";

export type Erdteil = "europa" | "andere";

export interface Land {
  id: number;
  iso2: string;
  nameDe: string;
  plateLetter: string;
  flagStyle: string;
  continent: Erdteil;
  sortOrder: number;
}

export interface Kennzeichen {
  id: number;
  countryId: number;
  code: string;
  regionNames: string[];
  stateName: string | null;
  /** Nur die heutige Zuordnung. Zaehlt fuer "gesehen", waehrend stateName fuer "gesamt" zaehlt. */
  stateNameCurrent: string | null;
  derivation: string | null;
  scope: PlateScope;
  status: PlateStatus;
  points: number;
  sortKey: string;
  /** Kraftfahrzeuge insgesamt im zugehoerigen Zulassungsbezirk (KBA). Null bei Bundesweit/Diplomaten/Laenderkennzeichen. */
  vehicleCountApprox: number | null;
}

export interface Bundle {
  bundleVersion: string | null;
  laender: Land[];
  kennzeichen: Kennzeichen[];
}

export function useBundle() {
  return useQuery({
    queryKey: ["plates-bundle"],
    // Stammdaten aendern sich praktisch nie waehrend eine Sitzung laeuft.
    staleTime: 30 * 60 * 1000,
    queryFn: () => holeBundleMitCache<Bundle>("plates", "/plates/bundle"),
  });
}
